/**
 * Ensures a stored website field is safe to use as an absolute `href` or `window.open` URL.
 * If the value already starts with `http`, it is returned trimmed; otherwise `https://` is prepended.
 */
export function normalizeExternalUrl(input: string | null | undefined): string {
  if (!input?.trim()) return '';
  const trimmed = input.trim();
  if (trimmed.startsWith('http')) return trimmed;
  return `https://${trimmed}`;
}

/**
 * Hostname only for display — protocol and path stripped (`1oakautos.com`).
 * Uses the first comma-separated value when a dealer has multiple websites.
 */
export function formatWebsiteHostname(input: string | null | undefined): string {
  const first = input?.split(',')[0]?.trim() || '';
  if (!first) return '';
  try {
    return new URL(normalizeExternalUrl(first)).hostname;
  } catch {
    return first.replace(/^https?:\/\//i, '').split('/')[0] || '';
  }
}
